import React, { useContext } from 'react'
import { HeaderButtonsStyles } from './Style'
import { Tabs } from 'components'
import { SchoolContext } from './SchoolContext'
import { schoolHooks } from '.'
import { LightButton } from 'styles/GlobalStyle'

const HeaderButtons = () => {
    const { setSelectedTab, selectedTab } = useContext(SchoolContext)

    const tabs = schoolHooks.useTabs()
    const currentTab = tabs[selectedTab]

    return (
        <HeaderButtonsStyles>
            <Tabs
                handleTab={setSelectedTab}
                tabs={tabs}
                defaultValue={selectedTab}
            />
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {currentTab?.headerExtra}
                {currentTab?.headerBtns.map((btn, index) =>
                    <LightButton size="small" key={index} {...btn} />
                )}
            </div>
        </HeaderButtonsStyles>
    )
}

export default HeaderButtons